import { DateManager } from 'utils';

import { MapComplementaryDataOptions } from '../types';

export const localTimeMap = (
  value: unknown,
  options?: MapComplementaryDataOptions
): string | undefined => {
  return value && typeof value === 'string'
    ? DateManager.getFormattedTime(value, options?.timeFormat)
    : undefined;
};
